import Joi from '@hapi/joi';
import { User } from 'types';
import validate from './validate';
import { emailRules, userNameRules } from './utils/common';

export const schema = Joi.object<Partial<User>>({
  firstName: Joi.string().max(255).required().messages({
    'string.max': 'STRING_MAX',
    'string.empty': 'REQUIRED_FIELD',
  }),
  lastName: Joi.string().max(255).required().messages({
    'string.max': 'STRING_MAX',
    'string.empty': 'REQUIRED_FIELD',
  }),
  userName: userNameRules(),
  email: emailRules(),
  profileID: Joi.number().required().messages({
    'any.required': 'REQUIRED_FIELD',
  }),
  trainTypeIDs: Joi.array().items(Joi.number().required()).messages({
    'array.includesRequiredUnknowns': 'INCOMPLETE_ERROR',
  }),
});

export default function (value: Partial<User>) {
  return validate(schema, value, {
    allowUnknown: true,
  });
}
